import Cookies from 'universal-cookie'
import { Api, VD_CUSTOMER_BFF_URL } from 'src/service'
import { jwtDecode } from 'jwt-decode'

export const cookies = new Cookies()

export const CUSTOMER_AREA_AUTH_TOKEN_KEY = 'token'

type CustomerAreaJwtAuthToken = {
  token: string
}

export const buildOrderUrl = (orderId: string) =>
  `${VD_CUSTOMER_BFF_URL}/v1/customer/orders/${orderId}/resellerSlug`

export const getResellerSlugFromOrderId = (orderId?: string) => {
  if (!orderId) {
    return Promise.reject(new Error('Missing Order ID'))
  }

  const authToken: string = cookies.get(CUSTOMER_AREA_AUTH_TOKEN_KEY)
  if (authToken) {
    const { token: customerAuthToken } = jwtDecode<CustomerAreaJwtAuthToken>(authToken)

    if (!customerAuthToken) {
      return Promise.reject(new Error('Missing token'))
    }
    return Api.get(buildOrderUrl(orderId), {
      headers: {
        Authorization: `Bearer ${customerAuthToken}`,
      },
    })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.message))
  }
  return Promise.reject(new Error('Missing Auth Token'))
}
